import { Button } from "@/components/ui/button";
import { ShieldAlert, TrendingDown, Scale } from "lucide-react";

const Hero = () => {
  const scrollToCalculator = () => {
    document.getElementById("calculadora")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative flex min-h-[80vh] items-center py-16 lg:py-24 bg-primary overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{ background: "var(--gradient-hero)" }}
      />
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjA1KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-30" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 lg:mb-6 leading-tight text-white">
            Você pode estar pagando <span className="text-accent">juros abusivos</span> sem saber
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl mb-6 lg:mb-8 text-white/90 leading-relaxed">
            Use nossa calculadora gratuita para descobrir se a taxa do seu contrato
            está acima do permitido e recupere o que foi pago a mais.
          </p>

          <div className="space-y-3 mb-6 lg:mb-8">
            <div className="flex items-start gap-2 lg:gap-3">
              <ShieldAlert className="w-5 h-5 lg:w-6 lg:h-6 text-accent mt-0.5 flex-shrink-0" />
              <p className="text-base lg:text-lg text-white/90">
                <strong className="text-white">Milhares de brasileiros pagam juros acima da média sem saber.</strong>
              </p>
            </div>
            <div className="flex items-start gap-2 lg:gap-3">
              <TrendingDown className="w-5 h-5 lg:w-6 lg:h-6 text-accent mt-0.5 flex-shrink-0" />
              <p className="text-base lg:text-lg text-white/90">
                <strong className="text-white">Recupere valores pagos a mais com revisão contratual.</strong>
              </p>
            </div>
            <div className="flex items-start gap-2 lg:gap-3">
              <Scale className="w-5 h-5 lg:w-6 lg:h-6 text-accent mt-0.5 flex-shrink-0" />
              <p className="text-base lg:text-lg text-white/90">
                <strong className="text-white">Análise gratuita do seu contrato por advogados especialistas.</strong>
              </p>
            </div>
          </div>

          <Button
            size="lg"
            variant="gold"
            className="font-semibold text-base w-full sm:w-auto"
            onClick={scrollToCalculator}
          >
            Calcule Agora
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
